<template>
    <div class="customer-linked-accounts">
        <v-container d-flex align-center justify-center v-if="linkedAccounts.loading" class="mt-10">
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
        </v-container>
        <div v-if="!linkedAccounts.loading">
            <div v-for="item of linkedAccounts.data" v-bind:key="item.orderId">
                <LinkedAccountsElement
                    :ssoId="ssoId"
                    :loading="linkedAccounts.loading"
                    :linkedAccounts="item"
                    @dataChanged="reload"
                    />
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapState,
    mapActions,
} from 'vuex';
import LinkedAccountsElement from '@/components/customer/LinkedAccountsElement.vue';

export default {
    name: 'LinkedAccountsOverview',
    components: {
        LinkedAccountsElement,
    },
    mounted() {
        this.resetState();
        this.ssoId = this.$route.params.sso_id || '';
        this.initStateAction(this.ssoId);
    },
    data() {
        return {
            ssoId: '',
        };
    },
    methods: {
        ...mapActions('customerLinkedAccounts', {
            initStateAction: 'initState',
            resetState: 'resetState',
        }),
        reload() {
            this.initStateAction(this.ssoId);
        },
        ...mapActions('customerLinkedAccounts', ['getLinkedAccounts']),
    },
    computed: {
        ...mapState('customerLinkedAccounts', [
            'linkedAccounts',
        ]),
    },
};

</script>

<style scoped lang="scss">
</style>
